import * as React from 'react';

import * as S from '../../../../../shared/pages/SRP/containers/NavigationHeader/NavigationHeader.styles';
import SrpTab from '../SrpTab/SrpTab';
import * as L from '../../../hotels/SRP/Autosuggests/LocationAndHotelSearch/LocationAndHotelSearch.styles';
import {BaseColumnWrap} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

const NavigationHeaderLoader = () => {
  return (
    <>
      <BaseColumnWrap>
        <S.TabLocationSearchWrapper
          heightStyle={'4.8rem'}
          overflow={'visible'}
          marginStyle={'1rem auto 0 auto'}
        >
          <SrpTab />
        </S.TabLocationSearchWrapper>
        <S.QuickFiltersAndSortingOuterWrap>
          <S.QuickFiltersAndSortingWrapper>
            <S.QuickFiltersWrapper>
              <S.QuickLocationLoader />
              <S.QuickLocationLoader />
              <S.QuickLocationLoader />
              <S.QuickLocationLoader />
            </S.QuickFiltersWrapper>
            {/* <S.LocationAndSortByOuterWrap>
              <L.SearchInput />
            </S.LocationAndSortByOuterWrap> */}
          </S.QuickFiltersAndSortingWrapper>
        </S.QuickFiltersAndSortingOuterWrap>
      </BaseColumnWrap>
      {/* <S.RightDoubleArrowOuterWrap onClick={() => {}} backgroundStyle={'white'}>
        <S.RightDoubleArrowIconWrap transformStyle={'rotate(-90deg)'} />
      </S.RightDoubleArrowOuterWrap> */}
    </>
  );
};

export default NavigationHeaderLoader;
